import { useRouter } from "next/router";
import { useEffect } from "react";
import { resetSearchToggle, resetSearchWord } from "src/reducks/SearchStore";
import { useAppDispatch } from "src/store/hooks";

// ページ遷移時に検索機能をリセットする
export const useSearchReset = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  useEffect(() => {
    const resetSearchValue = () => {
      dispatch(resetSearchWord());
      dispatch(resetSearchToggle());
    };
    router.events.on("routeChangeComplete", resetSearchValue);
    return () => {
      router.events.off("routeChangeComplete", resetSearchValue);
    };
  }, [dispatch, router.asPath, router.events]);
};
